import script from "./workspaceDescriptionList.vue?vue&type=script&lang=ts&setup=true"
export * from "./workspaceDescriptionList.vue?vue&type=script&lang=ts&setup=true"

import "./workspaceDescriptionList.vue?vue&type=style&index=0&id=bc61fee2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc61fee2"]])

export default __exports__